import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const InexperienceDriverExcess = (props) => {
  return (
    <FormGroup controlId="inexperienceDriverExcess">
      <Col componentClass={ControlLabel} sm={5}>
        Inexperienced Driver Excess (HKD)
      </Col>
      <Col sm={7}>
          <FormControl
            type="text"
            maxLength="60"
            value={props.inexperienceDriverExcess}
            autoComplete="off"
            onChange={props.handleChangeInexperienceDriverExcess} />
      </Col>
    </FormGroup>
  )
}

InexperienceDriverExcess.propTypes = {
  inexperienceDriverExcess: PropTypes.string,
  handleChangeInexperienceDriverExcess: PropTypes.func
};

export default InexperienceDriverExcess;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/inexperienceDriverExcess/InexperienceDriverExcess.js